module.exports = __webpack_public_path__ + "img/logo-bayer.a694975c.png";